module.exports = __webpack_public_path__ + "img/paper_plane_solo.d6c49ea9.svg";